import { c as _c } from "react/compiler-runtime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import type { ApiWave } from "@/generated/models/ApiWave";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import Image from "next/image";
import Link from "next/link";
interface WaveRatingRepProps {
  readonly wave: ApiWave;
}
export default function WaveRatingRep(t0) {
  const $ = _c(13);
  const {
    wave
  } = t0;
  const category = wave.voting.credit_category;
  const creditor = wave.voting.creditor;
  const hasCategory = !!category;
  const hasCreditor = !!creditor;
  if (!hasCategory && !hasCreditor) {
    return null;
  }
  let t1;
  if ($[0] !== creditor?.handle || $[1] !== creditor?.pfp) {
    t1 = creditor?.handle?.charAt(0).toUpperCase() ?? creditor?.pfp?.charAt(0).toUpperCase() ?? "?";
    $[0] = creditor?.handle;
    $[1] = creditor?.pfp;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const creditorInitial = t1;
  let t2;
  if ($[3] !== category || $[4] !== hasCategory) {
    t2 = hasCategory && <div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-3 tw-rounded-lg tw-bg-iron-900 tw-px-3 tw-py-2"><span className="tw-font-medium tw-text-iron-400">Category</span><span className="tw-break-words tw-text-right tw-font-semibold tw-text-iron-50">{category}</span></div>;
    $[3] = category;
    $[4] = hasCategory;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== creditor || $[7] !== creditorInitial || $[8] !== hasCreditor) {
    t3 = hasCreditor && <div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-3 tw-rounded-lg tw-bg-iron-900 tw-px-3 tw-py-2" aria-label={`Creditor ${creditor.handle ?? "unknown"}`}><span className="tw-font-medium tw-text-iron-400">Creditor</span><div className="tw-flex tw-min-w-0 tw-items-center tw-gap-2">{creditor.pfp ? <Image className="tw-h-6 tw-w-6 tw-flex-shrink-0 tw-rounded-full tw-bg-iron-800 tw-object-cover" src={getScaledImageUri(creditor.pfp, ImageScale.W_AUTO_H_50)} alt={creditor.handle ?? ""} width={24} height={24} /> : <div className="tw-flex tw-h-6 tw-w-6 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-iron-700 tw-bg-iron-800 tw-text-xs tw-font-semibold tw-text-iron-200">{creditorInitial}</div>}{creditor.handle ? <Link href={`/${creditor.handle}`} className="tw-truncate tw-font-semibold tw-text-iron-50 tw-no-underline tw-transition-colors hover:tw-text-iron-200"><UserProfileTooltipWrapper user={creditor.handle}><span className="tw-truncate">{creditor.handle}</span></UserProfileTooltipWrapper></Link> : <span className="tw-font-semibold tw-text-iron-200">Unknown</span>}</div></div>;
    $[6] = creditor;
    $[7] = creditorInitial;
    $[8] = hasCreditor;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <div className="tw-flex tw-w-full tw-flex-col tw-gap-2">{t2}{t3}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}